// process.env.<NAME> へのリテラルアクセスのみが Bun のフロントエンドバンドラで
// ビルド時に値置換される。動的アクセス (process.env[key]) は置換対象外なので、
// 変数を必ずベタ書きで参照する。
// https://bun.com/docs/bundler/fullstack#inline-environment-variables

/**
 * 同意管理 (CMP) タグを読み込むか ("true" で有効)。本番ビルドのみ有効にする
 * (値は infrastructure/deploy/guest/*.jsonc から注入される)。
 */
export const cmpEnabled: boolean = process.env.BUN_PUBLIC_CMP_ENABLED === "true";
